import store from '../../Store/store'
import i18next from './i18n'
import { getCurrentLanguage } from '../../Components/LanguageDropdown/getLanguageDropdownItems'

const updateLanguage = () => {
  const userLanguage = getCurrentLanguage(store.getState().user)

  if (i18next.language !== userLanguage) {
    i18next
      .changeLanguage(userLanguage)
      .catch((error) => console.error('Language change error:', error))
  }
}

updateLanguage()

store.subscribe(updateLanguage)

export { updateLanguage }
